import dayjs from "dayjs";

// Review periods start on Jan 1, May 1, Sep 1 (every 4 months)
// matching the Cloud Scheduler: "0 9 1 1,5,9 *"
const PERIOD_MONTHS = [0, 4, 8]; // Jan=0, May=4, Sep=8
const NOTIFICATION_WINDOW_DAYS = 21;

export function getCurrentPeriodStart(): Date {
  const now = dayjs();
  const year = now.year();

  const candidates = [
    ...PERIOD_MONTHS.map((m) => dayjs(new Date(year - 1, m, 1))),
    ...PERIOD_MONTHS.map((m) => dayjs(new Date(year, m, 1))),
    ...PERIOD_MONTHS.map((m) => dayjs(new Date(year + 1, m, 1))),
  ].sort((a, b) => a.valueOf() - b.valueOf());

  let periodStart = candidates[0];
  for (const c of candidates) {
    if (c.isBefore(now) || c.isSame(now, "day")) {
      periodStart = c;
    } else {
      break;
    }
  }
  return periodStart.toDate();
}

export function coordinatorReviewPeriodStartsBetween(
  from: Date,
  to: Date,
): Date[] {
  const periodStarts: Date[] = [];
  for (let year = from.getFullYear(); year <= to.getFullYear(); year++) {
    for (const month of PERIOD_MONTHS) {
      const periodStart = new Date(year, month, 1);
      if (periodStart > from && periodStart <= to) {
        periodStarts.push(periodStart);
      }
    }
  }
  return periodStarts;
}

export function isInNotificationWindow(): boolean {
  const periodStart = dayjs(getCurrentPeriodStart());
  const windowEnd = periodStart.add(NOTIFICATION_WINDOW_DAYS, "day");
  const now = dayjs();
  return (
    (now.isAfter(periodStart) || now.isSame(periodStart, "day")) &&
    now.isBefore(windowEnd)
  );
}

export function teacherMissingReviewForPeriod(
  teacherCreatedAt: string | null | undefined,
  latestReviewedAtUtc: string | null | undefined,
): boolean {
  const periodStart = getCurrentPeriodStart();

  if (teacherCreatedAt && new Date(teacherCreatedAt) >= periodStart) {
    return false;
  }

  if (!latestReviewedAtUtc) return true;
  return new Date(latestReviewedAtUtc) < periodStart;
}

export function teacherNeedsReview(
  teacherCreatedAt: string | null | undefined,
  latestReviewedAtUtc: string | null | undefined,
): boolean {
  if (!isInNotificationWindow()) return false;
  return teacherMissingReviewForPeriod(teacherCreatedAt, latestReviewedAtUtc);
}
